/**
 * CatalogadorPanel — shell del modulo QA del Catalogador IA.
 *
 * Sub-tabs horizontales arriba: Prompts | Golden Sets | Test Runs | A/B | Metricas | Cost | Settings.
 * El render condicional muestra el componente correspondiente debajo.
 *
 * Fase 1: Prompts + Golden Sets.
 * Fase 2: Test Runs + A/B Comparator.
 * Fase 3: Metricas Live + Cost Dashboard.
 * Fase 4: Settings.
 */
import React, { useState } from 'react';
import PromptsEditor from './PromptsEditor';
import GoldenSetManager from './GoldenSetManager';
import TestRunsRunner from './TestRunsRunner';
import ABComparator from './ABComparator';
import MetricsLive from './MetricsLive';
import CostDashboard from './CostDashboard';
import SettingsPanel from './SettingsPanel';
import './CatalogadorPanel.css';

const TABS = [
  { id: 'prompts',   label: 'Prompts'         },
  { id: 'golden',    label: 'Golden Sets'     },
  { id: 'runs',      label: 'Test Runs'       },
  { id: 'ab',        label: 'A/B Comparator'  },
  { id: 'metrics',   label: 'Metricas Live'   },
  { id: 'cost',      label: 'Cost Dashboard'  },
  { id: 'settings',  label: 'Settings'        },
];

export default function CatalogadorPanel() {
  const [activeTab, setActiveTab] = useState('prompts');

  const renderBody = () => {
    switch (activeTab) {
      case 'prompts':  return <PromptsEditor />;
      case 'golden':   return <GoldenSetManager />;
      case 'runs':     return <TestRunsRunner />;
      case 'ab':       return <ABComparator />;
      case 'metrics':  return <MetricsLive />;
      case 'cost':     return <CostDashboard />;
      case 'settings': return <SettingsPanel />;
      default:         return <PromptsEditor />;
    }
  };

  return (
    <div className="qa-panel">
      <div className="qa-tabs">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`qa-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            type="button"
          >
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
      <div className="qa-body">
        {renderBody()}
      </div>
    </div>
  );
}
